import React from "react";
import DatePicker from "../../shared/form/DatePicker";
import CheckBox from "../../shared/form/CheckBox";
import RadioButton from "../../shared/form/RadioButton";
import Main from "../../Main";
import Button from "../../shared/form/Button";
import childProtectpdf from "../../../assets/pdf/WVDF_Safeguarding_Policy_Behavior_Protocols.pdf";

const bestTimeNotice = {
    fontStyle: "italic",
    color: "#8b8b8b",
    background: "#ededed",
    padding: "10px 15px",
    marginTop: "10px"
};

const VisitChild = props => {
    return (
        <Main>
            <div className="island">
                <form id="webform-client-form-2949" onSubmit={props.submit}>
                    <div className="form-item">
                        <label>Select Child </label>
                        <div className="dropdown">
                            <button
                                className="btn btn-default dropdown-toggle widthAuto"
                                type="button"
                                id="dropdownMenu1"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="true"
                            >
                                {props.selectedChild}{" "}
                                <span className="caret"></span>
                            </button>
                            <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenu1"
                            >
                                {props.listChildren()}
                            </ul>
                        </div>
                    </div>

                    <div className="form-item">
                        <label>Date of Visit </label>
                        <DatePicker
                            minDate={+20}
                            change={props.getDatePickerValue}
                        />{" "}
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                        <p style={bestTimeNotice}>
                            The best time to visit the child is on weekends especially during school season.
                            <br />
                            Please also take note that we will not accept requests for December 18, 2019 to January 6, 2020 due to field staff unavailability.
                        </p>
                    </div>

                    <div className="form-item">
                        <label>Meet Sponsored Child with </label>
                        <CheckBox
                            values={["Mother", "Father", "Both", "Siblings"]}
                            getInputValue={props.getInputValue}
                            multi={true}
                            name="meetChildWith"
                        />
                    </div>

                    <div className="form-item">
                        <label>Time of Visits </label>
                        <RadioButton
                            name="visitTime"
                            values={["9AM - 12PM", "10AM - 1PM", "1PM - 3PM"]}
                            change={props.change}
                        />
                    </div>

                    <div className="form-item">
                        <label>With Gift </label>
                        <RadioButton
                            name="withGift"
                            values={["Yes", "No"]}
                            change={props.change}
                        />
                    </div>

                    <div className="form-item">
                        <label>Type of Gift </label>
                        <input
                            type="text"
                            name="typeOfGift"
                            value={props.values.typeOfGift}
                            onChange={props.change}
                            className="form-text"
                        />
                    </div>

                    <div className="form-item">
                        <label>List of Sponsor's Companions </label>
                        <div className="form-textarea-wrapper resizable textarea-processed resizable-textarea">
                            <textarea
                                name="sponsorCompanions"
                                cols="60"
                                rows="5"
                                value={props.values.sponsorCompanions}
                                onChange={props.change}
                                className="form-textarea form-control"
                            ></textarea>
                        </div>
                    </div>

                    <div className="form-item">
                        <label>Suggested Activities </label>
                        <CheckBox
                            values={[
                                "Snacks",
                                "Shopping",
                                "Lunch",
                                "Visit Museums/Educational Tour"
                            ]}
                            getInputValue={props.getInputValue}
                            multi={true}
                            name="activities"
                        />
                    </div>

                    <div className="form-item">
                        <label>Other </label>
                        <div className="form-textarea-wrapper resizable textarea-processed resizable-textarea">
                            <textarea
                                name="other"
                                cols="60"
                                rows="5"
                                value={props.values.other}
                                onChange={props.change}
                                className="form-textarea form-control"
                            ></textarea>
                        </div>
                    </div>

                    <div className="form-item form-type-radio">
                        <CheckBox
                            values={
                                "Agree to shoulder all expenses incurred during the visit.*"
                            }
                            getInputValue={props.getInputValue}
                            name="agreeToShoulderExpenses"
                        />
                    </div>

                    <div className="form-item form-type-radio">
                        <CheckBox
                            values={
                                <p>
                                    I agree to comply with{" "}
                                    <a href={childProtectpdf}>
                                        {" "}
                                        World Vision's Child Protection Policy
                                    </a>{" "}
                                    and adhere by them.*
                                </p>
                            }
                            getInputValue={props.getInputValue}
                            name="agreeToWorldvisionPolicy"
                        />
                    </div>

                    <p>
                        Cancellation must be made at least 10 days before the
                        proposed visit date. Please send your request 30 days
                        before your desired visit date
                    </p>

                    <div className="form-actions">
                        <Button loading={props.loading}>Submit</Button>
                    </div>
                </form>
            </div>
        </Main>
    );
};

export default VisitChild;
